import { render } from "./NcrmPrivacyMailjetSyncStatus.vue?vue&type=template&id=10642c6f&scoped=true"
import script from "./NcrmPrivacyMailjetSyncStatus.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyMailjetSyncStatus.vue?vue&type=script&lang=js"

import "./NcrmPrivacyMailjetSyncStatus.vue?vue&type=style&index=0&id=10642c6f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10642c6f"]])

export default __exports__